export default {
	exhibits: [],
	loading: false,
	errored: false,
	newExhibit:{},
	exhibit: {
		changedExhibit: null,
		loading: false,
		errored: false,
	}
};



// WEBPACK FOOTER //
// ./src/reducers/exhibit/exhibit-initialState.js